import { render } from "./ProductWithBadge.vue?vue&type=template&id=2b248cd9"
import script from "./ProductWithBadge.vue?vue&type=script&lang=js"
export * from "./ProductWithBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__